import { Injectable } from '@angular/core';
import { TokenRevocationInterceptor } from '@spartacus/core';
import { Observable, of } from 'rxjs';

import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { switchMap, take } from 'rxjs/operators';

/**
 * This interceptor overrides TokenRevocationInterceptor dedicated for Hybris OAuth server which requires `Authorization` header for revoke token calls.
 * It intercepts revoke refresh_token event and return success http response due to Hybris {
 *    "errors": [ {
 *       "type": ModelRemovalError
 *    } ]
 * } when removing refresh token.
 * By our hybris auth2 conf Hybris already removes refresh token when revoking access_token.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomTokenRevocationInterceptor extends TokenRevocationInterceptor {
  override intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isTokenRevocationRequest = this.isTokenRevocationRequest(request);
    return this.authStorageService.getToken().pipe(
      take(1),
      switchMap((token) => {
        if (isTokenRevocationRequest) {
          if (request.body.get('token_type_hint') == 'refresh_token') {
            return of(
              new HttpResponse({
                body: null,
                status: 200, // if the status is not 2xx, it will enter the error-callback
                statusText: 'OK',
              })
            );
          } else {
            request = request.clone({
              setHeaders: {
                Authorization: `${token.token_type || 'Bearer'} ${token.access_token}`,
              },
            });
          }
        }

        return next.handle(request);
      })
    );
  }

  protected override isTokenRevocationRequest(request: HttpRequest<any>): boolean {
    return request.url === this.authConfigService.getRevokeEndpoint();
  }
}
